(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header-mizar"] && !Shopify.designMode) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }
  }

  customElements.define('sticky-header', StickyHeader);

  // Mizar Drawer - Close button & Accordion
  document.addEventListener('DOMContentLoaded', () => {
    // Close button (uses span role="button" to avoid MenuDrawer's onCloseButtonClick)
    const closeBtn = document.querySelector('.mizar-drawer__close-btn');
    if (closeBtn) {
      const handleClose = () => {
        const headerDrawer = closeBtn.closest('header-drawer');
        if (headerDrawer) {
          const summary = headerDrawer.querySelector('summary');
          headerDrawer.closeMenuDrawer(new Event('click'), summary);
          summary.setAttribute('aria-expanded', false);
        }
      };
      closeBtn.addEventListener('click', handleClose);
      closeBtn.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          handleClose();
        }
      });
    }

    // Accordion triggers (uses div + JS to avoid MenuDrawer's onSummaryClick)
    // 開閉アニメーションは CSS の grid-template-rows が担当するためネストにも対応できる
    document.querySelectorAll('.mizar-drawer__accordion-trigger').forEach((trigger) => {
      const handleToggle = () => {
        // 直近のアコーディオンのみを開閉（ネスト時に親まで閉じないよう closest を使用）
        const accordion = trigger.closest('.mizar-drawer__accordion');
        const isOpen = accordion.classList.toggle('is-open');
        trigger.setAttribute('aria-expanded', String(isOpen));
      };
      trigger.addEventListener('click', handleToggle);
      trigger.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          handleToggle();
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-slider"] && !Shopify.designMode) return;
  try {
    
  class HeroSliderComponent extends HTMLElement {
    constructor() {
      super();
      this.originalSlides = this.querySelectorAll('.hero-slider__slide');
      this.slidesContainer = this.querySelector('.hero-slider__slides');
      this.prevButton = this.querySelector('.hero-slider__nav-button--prev');
      this.nextButton = this.querySelector('.hero-slider__nav-button--next');
      this.dots = this.querySelectorAll('.hero-slider__dot');
      this.currentIndex = 0;
      this.slideCount = this.originalSlides.length;
      this.autoplay = this.dataset.autoplay === 'true';
      this.speed = parseInt(this.dataset.speed, 10) * 1000 || 5000;
      this.slideWidth = parseInt(this.dataset.slideWidth, 10) || 900;
      this.autoplayInterval = null;
      this.isTransitioning = false;
    }

    connectedCallback() {
      if (this.slideCount <= 1) return;

      this.setupInfiniteLoop();
      this.setupEventListeners();
      this.updateSliderPosition(false);

      if (this.autoplay) {
        this.startAutoplay();
      }

      this.resizeObserver = new ResizeObserver(() => {
        this.updateSliderPosition(false);
      });
      this.resizeObserver.observe(this);
    }

    disconnectedCallback() {
      this.stopAutoplay();
      if (this.resizeObserver) {
        this.resizeObserver.disconnect();
      }
    }

    setupInfiniteLoop() {
      // Clone first and last slides for seamless loop
      const firstClone = this.originalSlides[0].cloneNode(true);
      const lastClone = this.originalSlides[this.slideCount - 1].cloneNode(true);

      firstClone.classList.add('hero-slider__slide--clone');
      lastClone.classList.add('hero-slider__slide--clone');
      firstClone.removeAttribute('id');
      lastClone.removeAttribute('id');

      this.slidesContainer.appendChild(firstClone);
      this.slidesContainer.insertBefore(lastClone, this.originalSlides[0]);

      // Update slides reference to include clones
      this.slides = this.querySelectorAll('.hero-slider__slide');
      // Start at index 1 (after the prepended clone)
      this.currentIndex = 1;
    }

    setupEventListeners() {
      if (this.prevButton) {
        this.prevButton.addEventListener('click', () => this.goToPrev());
      }

      if (this.nextButton) {
        this.nextButton.addEventListener('click', () => this.goToNext());
      }

      this.dots.forEach((dot, index) => {
        dot.addEventListener('click', () => this.goToSlide(index + 1));
      });

      this.addEventListener('mouseenter', () => this.stopAutoplay());
      this.addEventListener('mouseleave', () => {
        if (this.autoplay) this.startAutoplay();
      });

      let touchStartX = 0;
      this.addEventListener('touchstart', (e) => {
        touchStartX = e.changedTouches[0].screenX;
      }, { passive: true });

      this.addEventListener('touchend', (e) => {
        const touchEndX = e.changedTouches[0].screenX;
        const diff = touchStartX - touchEndX;
        if (Math.abs(diff) > 50) {
          diff > 0 ? this.goToNext() : this.goToPrev();
        }
      }, { passive: true });

      this.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowLeft') this.goToPrev();
        else if (e.key === 'ArrowRight') this.goToNext();
      });

      // Handle loop jump after transition
      this.slidesContainer.addEventListener('transitionend', () => {
        this.handleLoopJump();
      });
    }

    handleLoopJump() {
      // Jump to real slide without animation when at clone
      if (this.currentIndex === 0) {
        this.currentIndex = this.slideCount;
        this.updateSliderPosition(false);
      } else if (this.currentIndex === this.slideCount + 1) {
        this.currentIndex = 1;
        this.updateSliderPosition(false);
      }
      this.isTransitioning = false;
    }

    goToPrev() {
      if (this.isTransitioning) return;
      this.currentIndex--;
      this.updateSliderPosition(true);
      this.resetAutoplay();
    }

    goToNext() {
      if (this.isTransitioning) return;
      this.currentIndex++;
      this.updateSliderPosition(true);
      this.resetAutoplay();
    }

    goToSlide(index) {
      if (this.isTransitioning || index === this.currentIndex) return;
      this.currentIndex = index;
      this.updateSliderPosition(true);
      this.resetAutoplay();
    }

    updateSliderPosition(animate = true) {
      this.isTransitioning = animate;

      const containerWidth = this.querySelector('.hero-slider__container').offsetWidth;
      const slideElement = this.slides[0];
      const slideWidth = slideElement.offsetWidth;

      // モバイル (≤749px) は中央寄せ、それ以上は左寄せ
      const isMobile = window.innerWidth <= 749;
      const centerOffset = isMobile ? (containerWidth - slideWidth) / 2 : 0;
      const translateX = -(this.currentIndex * slideWidth) + centerOffset;

      this.slidesContainer.style.transition = animate ? 'transform 0.5s cubic-bezier(0.25, 0.1, 0.25, 1)' : 'none';
      this.slidesContainer.style.transform = `translateX(${translateX}px)`;

      // Update dots (adjust for clone offset)
      const realIndex = ((this.currentIndex - 1) % this.slideCount + this.slideCount) % this.slideCount;
      this.dots.forEach((dot, index) => {
        dot.classList.toggle('hero-slider__dot--active', index === realIndex);
        dot.setAttribute('aria-selected', index === realIndex ? 'true' : 'false');
      });

      if (!animate) {
        this.isTransitioning = false;
      }
    }

    startAutoplay() {
      if (this.autoplayInterval) return;
      this.autoplayInterval = setInterval(() => {
        this.goToNext();
      }, this.speed);
    }

    stopAutoplay() {
      if (this.autoplayInterval) {
        clearInterval(this.autoplayInterval);
        this.autoplayInterval = null;
      }
    }

    resetAutoplay() {
      this.stopAutoplay();
      if (this.autoplay) this.startAutoplay();
    }
  }

  customElements.define('hero-slider-component', HeroSliderComponent);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["popular-ranking"] && !Shopify.designMode) return;
  try {
    
  class PopularRankingComponent extends HTMLElement {
    constructor() {
      super();
      this.slidesContainer = this.querySelector('.popular-ranking__slides');
      this.slides = this.querySelectorAll('.popular-ranking__slide');
      this.prevButton = this.querySelector('.popular-ranking__nav-button--prev');
      this.nextButton = this.querySelector('.popular-ranking__nav-button--next');
      this.currentPosition = 0;
    }

    connectedCallback() {
      if (this.slides.length <= 1) return;

      this.setupEventListeners();
      this.updateButtonStates();

      // リサイズ時はスライド位置も再計算（モバイル/デスクトップでスライド幅が変わるため）
      this.resizeObserver = new ResizeObserver(() => {
        const maxPos = this.getMaxPosition();
        if (this.currentPosition > maxPos) {
          this.currentPosition = maxPos;
        }
        this.updateSliderPosition();
      });
      this.resizeObserver.observe(this);
    }

    disconnectedCallback() {
      if (this.resizeObserver) {
        this.resizeObserver.disconnect();
      }
    }

    setupEventListeners() {
      if (this.prevButton) {
        this.prevButton.addEventListener('click', () => this.goToPrev());
      }

      if (this.nextButton) {
        this.nextButton.addEventListener('click', () => this.goToNext());
      }

      // Touch/swipe support
      let touchStartX = 0;
      this.addEventListener('touchstart', (e) => {
        touchStartX = e.changedTouches[0].screenX;
      }, { passive: true });

      this.addEventListener('touchend', (e) => {
        const touchEndX = e.changedTouches[0].screenX;
        const diff = touchStartX - touchEndX;
        if (Math.abs(diff) > 50) {
          diff > 0 ? this.goToNext() : this.goToPrev();
        }
      }, { passive: true });

      // Keyboard support
      this.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowLeft') this.goToPrev();
        else if (e.key === 'ArrowRight') this.goToNext();
      });
    }

    // 実DOMから1スライド分の移動量（幅 + gap）を算出する
    getSlideOffset() {
      if (this.slides.length >= 2) {
        return this.slides[1].offsetLeft - this.slides[0].offsetLeft;
      }
      return this.slides[0].offsetWidth;
    }

    getVisibleSlides() {
      const containerWidth = this.querySelector('.popular-ranking__slides-wrapper').offsetWidth;
      const offset = this.getSlideOffset();
      if (offset <= 0) return 1;
      return Math.max(1, Math.floor(containerWidth / offset));
    }

    getMaxPosition() {
      const visibleSlides = this.getVisibleSlides();
      return Math.max(0, this.slides.length - visibleSlides);
    }

    goToPrev() {
      if (this.currentPosition > 0) {
        this.currentPosition--;
        this.updateSliderPosition();
      }
    }

    goToNext() {
      const maxPosition = this.getMaxPosition();
      if (this.currentPosition < maxPosition) {
        this.currentPosition++;
        this.updateSliderPosition();
      }
    }

    updateSliderPosition() {
      const translateX = -(this.currentPosition * this.getSlideOffset());
      this.slidesContainer.style.transform = `translateX(${translateX}px)`;
      this.updateButtonStates();
    }

    updateButtonStates() {
      const maxPosition = this.getMaxPosition();

      if (this.prevButton) {
        this.prevButton.disabled = this.currentPosition === 0;
      }

      if (this.nextButton) {
        this.nextButton.disabled = this.currentPosition >= maxPosition || maxPosition <= 0;
      }
    }
  }

  customElements.define('popular-ranking-component', PopularRankingComponent);

  } catch(e) { console.error(e); }
})();
})();
